<template>
  <div>
    <div v-if="hasLog">
      <section-title content="Historial de Custodio" has-line class="mt-4" />
      <div v-for="(item, idx) in logItems" :key="idx">
        <timeline-item :date="item.date">
          <div class="row w-100">
            <div class="col-12 col-lg-2">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Estatus del Libro:
              </label>
              <custom-balloon
                :background-color="item.statusColor"
                :text="item.statusName"
                dot
              />
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Centro:
              </label>
              <p>{{ item.center }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Nombre de Maestro:
              </label>
              <p>{{ item.teacherName }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Nombre del Estudiante:
              </label>
              <p>{{ item.studentName }}</p>
            </div>
          </div>
        </timeline-item>
      </div>
      <div class="row my-4">
        <div class="col text-center">
          <action-button
            v-if="showMore"
            variant="outline-success custom-view-more actionButton"
            i="fas fa-chevron-down"
            @click="handlerMore"
          >
            Ver más
          </action-button>
        </div>
      </div>
    </div>
    <custom-result-not-found v-else text="No hay Información Disponible." />
  </div>
</template>

<script>
import CustomResultNotFound from "custom-result-not-found";
import ActionButton from "ActionButton";
import TimelineItem from "@quisit/timeline-item";
import CustomBalloon from "custom-balloon";
import inventoryService from "@/services/api/inventorycatalog.api";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import SectionTitle from "SectionTitle";

export default {
  name: "BookHistory",
  components: {
    TimelineItem,
    CustomResultNotFound,
    ActionButton,
    CustomBalloon,
    SectionTitle
  },
  mixins: [alertMixin],
  props: {
    book: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      history: [],
      logCount: 5
    };
  },
  computed: {
    bookId() {
      return Number(this.$route.params.bookId);
    },
    logItems() {
      const items = this.history
        .map(item => {
          return {
            ...item,
            date: item.date
          };
        })
        .slice(0, this.logCount);
      return items;
    },
    hasLog() {
      return this.history.length > 0;
    },
    showMore() {
      return this.history.length > this.logCount && this.history.length > 5;
    }
  },
  async mounted() {
    await this.getHistory();
  },
  methods: {
    async getHistory() {
      try {
        const { data } = await inventoryService.getAssignmentHistory(
          this.bookId
        );
        this.history = data;
      } catch (error) {
        this.ShowToast("Error", error, "error");
      }
    },
    handlerMore() {
      this.logCount += 5;
    }
  }
};
</script>

<style></style>
